import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_VENUES_LIST = gql`
query getVenuesList ($search: String, $limit: Int, $offset: Int, $sortField: String, $sortOrder: Int){
    getVenuesList(search: $search, limit: $limit, offset: $offset, sortField: $sortField, sortOrder: $sortOrder) {
      isAuth
      total
      venues {
        _id
        venueSlugName
        venueName
        venueReadableName {
          en
          es
          ca
          pt
        }
        description {
          en
          es
          ca
          pt
        }
        image {
          en
          es
          ca
          pt
        }
        postUri
        address
        location
        country
        phone
        latitude
        longitude
        capacity
        createdAt
      }
    }
  }
`;

const getVenuesList = async (search = '', { limit, offset, sortField, sortOrder } = {}) => {
  try {
    const result = await client
      .query({
        query: GET_VENUES_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
        variables: { search, limit, offset, sortField, sortOrder },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getVenuesList: venuesListData },
    } = result;

    if (venuesListData) {
      return venuesListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getVenuesList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getVenuesList Error: ${error}`);
    return null;
  }
};

export default getVenuesList;
